import { IProductDto } from 'api/products/dto';

export const calculatePriceInTotal = (items: Record<string, IProductDto[]>) => {
  if (!items) return 0;
  return Object.values(items)
    .flat()
    .reduce((sum, product) => sum + (product.discountedPrice ?? 0) * (product.quantity ?? 0), 0);
};
